import classNames from 'classnames';
import { useState } from 'react';

interface CheckIconProps {
  isSelected: boolean;
  isHighlighted?: boolean;
}
const CheckIcon = ({ isSelected, isHighlighted }: CheckIconProps) => {
  return (
    <span
      className={classNames(
        'absolute inset-y-0 left-0 flex items-center pl-1.5 hover:text-white text-indigo-600',
        {
          'text-white': isSelected && isHighlighted,
          'text-indigo-600': isSelected && !isHighlighted,
          'text-transparent': !isSelected,
        }
      )}
      aria-hidden="true"
    >
      <svg
        className={classNames('h-5 w-5')}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden="true"
      >
        <path
          fillRule="evenodd"
          d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z"
          clipRule="evenodd"
        ></path>
      </svg>
    </span>
  );
};

interface OptionItemProps {
  isSelected: boolean;
  onClick: () => void;
  label?: string;
}

export const OptionItem = ({ isSelected, onClick, label }: OptionItemProps) => {
  const [isHighlighted, setIsHighlighted] = useState(false);
  return (
    <li
      onMouseEnter={() => setIsHighlighted(true)}
      onMouseLeave={() => setIsHighlighted(false)}
      className={classNames(
        'text-gray-900 hover:bg-indigo-600 hover:text-white relative cursor-default select-none py-2 pl-8 pr-4'
      )}
      role="option"
    >
      <button type="button" onClick={onClick}>
        <span
          className={classNames('block truncate', {
            'font-normal': !isSelected,
            'font-semibold': isSelected,
          })}
        >
          {label}
        </span>
        <CheckIcon isSelected={isSelected} isHighlighted={isHighlighted} />
      </button>
    </li>
  );
};

export default OptionItem;
